module.exports = __webpack_public_path__ + "static/media/06-03.db87c16d.png";